
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17px","height":"15px","viewBox":"0 0 17 15","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Clinic","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(-150.000000, -596.000000)","fill":"#62666D","fill-rule":"nonzero","id":"Breadcrumbs"}},[_c('g',{attrs:{"transform":"translate(150.000000, 596.000000)"}},[_c('g',{attrs:{"id":"home-button"}},[_c('polygon',{attrs:{"id":"Path","points":"6.72 14.4 6.72 9.31764706 10.08 9.31764706 10.08 14.4 14.28 14.4 14.28 7.62352941 16.8 7.62352941 8.4 0 0 7.62352941 2.52 7.62352941 2.52 14.4"}})])])])])])
          )
        }
      }
    